<template>
  <div id="menu" class="position-absolute top-0 px-1 d-flex">
    <pc>
      <div class="logo w-15">
        <img :src="img.logo" alt="" class="w-100">
      </div>
      <ul class="pc">
        <li><a href="#sec-1"><img :src="img.menuItem.pc.l1" alt="" class="w-100"></a></li>
        <li><a href="#sec-2"><img :src="img.menuItem.pc.l2" alt="" class="w-100"></a></li>
        <li><a href="#sec-3"><img :src="img.menuItem.pc.l3" alt="" class="w-100"></a></li>
        <li><a href="#sec-4"><img :src="img.menuItem.pc.l4" alt="" class="w-100"></a></li>
        <li><a href="#sec-5"><img :src="img.menuItem.pc.l5" alt="" class="w-100"></a></li>
        <li><a href="#sec-6"><img :src="img.menuItem.pc.l6" alt="" class="w-100"></a></li>
        <li><a href="#sec-7"><img :src="img.menuItem.pc.l7" alt="" class="w-100"></a></li>
        <li><a href="#sec-8"><img :src="img.menuItem.pc.l8" alt="" class="w-100"></a></li>
        <li><a href="#sec-9"><img :src="img.menuItem.pc.l9" alt="" class="w-100"></a></li>
        <li><a href="#sec-10"><img :src="img.menuItem.pc.l10" alt="" class="w-100"></a></li>
      </ul>
    </pc>
    <div v-if="states.isMobile && show">
      <div class="overlap position-fixed top-0 w-100 vh-100" @click="closeMenu"></div>
      <ul class="mb position-fixed top-0 w-75 vh-100 flex-column">
        <li :style="{marginBottom: '-22px'}"><a href="#sec-1" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l1" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: '-14px'}"><a href="#sec-2" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l2" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: '-13px'}"><a href="#sec-3" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l3" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: '-12px'}"><a href="#sec-4" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l4" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: '-16px'}"><a href="#sec-5" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l5" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: '-1px'}"><a href="#sec-6" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l6" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: '-15px'}"><a href="#sec-7" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l7" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: '-12px'}"><a href="#sec-8" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l8" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: '-1px'}"><a href="#sec-9" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l9" alt="" class="w-100"></a></li>
        <li :style="{marginBottom: 0}"><a href="#sec-10" class="w-100" @click.prevent="goTo($event)"><img :src="img.menuItem.mb.l10" alt="" class="w-100"></a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Pc from "@/components/Pc";
export default {
  name: "XMenu",
  inject: ['states'],
  props: ['show', 'closeMenu'],
  components: {Pc},
  data() {
    return {
      img: {
        logo: require('../assets/img/logo.png'),
        menuItem: {
          pc: {
            l1: require('../assets/img/pc/pclist01.png'),
            l2: require('../assets/img/pc/pclist02.png'),
            l3: require('../assets/img/pc/pclist03.png'),
            l4: require('../assets/img/pc/pclist04.png'),
            l5: require('../assets/img/pc/pclist05.png'),
            l6: require('../assets/img/pc/pclist06.png'),
            l7: require('../assets/img/pc/pclist07.png'),
            l8: require('../assets/img/pc/pclist08.png'),
            l9: require('../assets/img/pc/pclist09.png'),
            l10: require('../assets/img/pc/pclist10.png'),
          },
          mb: {
            l1: require('../assets/img/mb/list01.png'),
            l2: require('../assets/img/mb/list02.png'),
            l3: require('../assets/img/mb/list03.png'),
            l4: require('../assets/img/mb/list04.png'),
            l5: require('../assets/img/mb/list05.png'),
            l6: require('../assets/img/mb/list06.png'),
            l7: require('../assets/img/mb/list07.png'),
            l8: require('../assets/img/mb/list08.png'),
            l9: require('../assets/img/mb/list09.png'),
            l10: require('../assets/img/mb/list10.png'),
          }
        }
      }
    }
  },
  methods: {
    goTo(e) {
      location.href = e.currentTarget.href
      this.closeMenu()
    }
  }
}
</script>

<style scoped lang="scss">

</style>